import { render, staticRenderFns } from "./ClienteEmpresaModal.vue?vue&type=template&id=0cb74e9f&scoped=true&lang=pug"
import script from "./ClienteEmpresaModal.vue?vue&type=script&lang=js"
export * from "./ClienteEmpresaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb74e9f",
  null
  
)

export default component.exports